import React from "react"
import { FormattedMessage } from "react-intl"

export interface RateProps {
	title: string
	color: string
	count: number
	value: number
}

const Rate: React.FC<RateProps> = ({ title, color, count, value }) => {
	return (
		<div className="summarycard-rate">
			<FormattedMessage id={title} />
			<div className="summarycard-rank">
				{Array.from(Array(count).keys()).map((countValue, index) => {
					const available = value - countValue > 0
					return (
						<span
							key={`summarycard-rank-${index}-${color}`}
							style={{ backgroundColor: available ? color : undefined }}
							className="rate-badge"
						/>
					)
				})}
			</div>
		</div>
	)
}

export default Rate
